module.exports = "/virtual-football-league/img/video/clubs/england/arsenal.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/video/clubs/england/arsenal.png
// module id = 333
// module chunks = 4